module.exports = __webpack_public_path__ + "assets/4295275ef8fbf3f506af8fb55dece58c.png";